import { useEffect, useState } from 'react'
import { Col, Container, Form, Row } from 'react-angle-dashboard-components'
import { useFormContext } from 'react-hook-form'
import { IQuoteFormData } from '../../QuoteForm'
import { Heading, SmallGrayHeading } from '../../style'
import FooterNav from '../../FooterNav'
import { useVendorChoices } from '../../../../hooks/quote.hooks'
import { IVendorChoicesDTO } from '../../../../services/quote/dto'
import AddOnProgramsSectionsContainer from './AddOnProgramsSectionsContainer'

const PlanInfoStep2 = () => {
  const { watch } = useFormContext<IQuoteFormData>()

  const { data } = useVendorChoices(watch('entryId'))

  const [programData, setProgramData] = useState<IVendorChoicesDTO | undefined>(
    undefined
  )
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    if (data && data.addOns) {
      setProgramData(data)
    }
  }, [data])

  return (
    <Container className="p-4">
      <Row className="pb-5">
        <Col>
          <SmallGrayHeading>Plan Info (2/2)</SmallGrayHeading>
          <Heading className="pt-1">Select Additional Programs</Heading>
        </Col>
        <Col sm={4}>
          <Form.Control
            placeholder="Search by vendor name"
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Col>
      </Row>
      { programData && programData.addOns &&
      <AddOnProgramsSectionsContainer addOnPrograms={programData.addOns} searchText={searchText} />}
      <FooterNav triggerPath="planInfo.step2" />
    </Container>
  )
}

export default PlanInfoStep2
